export const state = {
    'showStartPage': false,
    'payinCrypto': false,
    'payoutCrypto': false,
    'payinCryptoType': undefined,
    'orderId': undefined,
    'organization': {},
    'theme': undefined,
    'payinCryptoInvoicePayerEmailAllow': undefined,
    'payinCryptoInvoicePayerEmailRequired': false,
    'payinCryptoInvoiceFree': undefined,
    'payinCryptoCurrenciesTo': [],
    'payinCryptoInvoiceCurrencies': [],
    'payoutCryptoPayerEmailAllow': undefined,
    'payoutCryptoPayerEmailRequired': false,
    'payoutCryptoCurrencyFrom': [],
    'payoutCryptoCurrenciesTo': [],
    'payoutCryptoAmountFrom': undefined,
    'personalUserInfo': undefined,
    'fiatId': undefined,
    'fiatSettings': {},

    // параметры отвечающие за вертикальные размеры виджета
    'withoutFooter': false,
    'withoutTitle': false,
    'widgetSize': undefined,
    'widgetWidth': undefined,
    'widgetHeight': undefined,
    'widgetFooterHeight': undefined,
    'widgetTitleHeight': undefined,

    'openedModal': {
        'name': undefined,
        'payload': undefined,
    },
    'lang': undefined,

    // for INVOICE
    'invoiceInfo': {},
    'orderInfo': undefined
}